import { ChangeDetectionStrategy, Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { FiLoginReminderHelperService } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder-helper.service';
import { ILoginReminder } from '@fi-app/other-settings/fi-login-reminder/fi-login-reminder';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-login-reminder-edit-navigation-tabs',
    templateUrl: './fi-login-reminder-navigation-tabs.component.html',
    styleUrl: './fi-login-reminder-navigation-tabs.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-login-reminder-edit-navigation-tabs' },
    standalone: false,
})
export class FiLoginReminderNavigationTabsComponent extends TabsModuleBase implements OnInit {
    @Input() loginReminder: ILoginReminder;

    constructor(
        injector: Injector,
        private fiLoginReminderHelperService: FiLoginReminderHelperService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        if (!this.loginReminder.Id) {
            // no saved reminder, go to edit
            this.stateService.go(FiStateNames.OtherSettings.LoginReminder.Edit, { loginReminder: this.loginReminder });
        } else {
            // saved reminder exists, init tabs and goto 1st one
            this.tabs = this.fiLoginReminderHelperService.getLoginReminderSettingsTabs(this.loginReminder);
            if (this.tabs.length > 0) {
                if (this.stateService.current.name === FiStateNames.OtherSettings.LoginReminder._name) {
                    super.onTabIndexChange(0);
                } else {
                    this.updateSelectedTabFromState();
                }
            }
        }
    }

    protected isTabsHidden(): boolean {
        return this.stateService.current.name === FiStateNames.OtherSettings.LoginReminder.Edit;
    }

    protected onEditButtonClick() {
        this.stateService.go(FiStateNames.OtherSettings.LoginReminder.Edit, { loginReminder: this.loginReminder });
    }
}
